// extracted by mini-css-extract-plugin
module.exports = {"layout":"component-module--layout--IQzWu","main":"component-module--main--3tBGr"};